import { shapeDate } from '@avangard/utils/data';
import { BaseEntity, Entity as DecribeEntity } from '@avangard/utils/entity';

import type { StudentParent } from '@modules/types/graphql';

export type Entity = Partial<StudentParent> | null;

@DecribeEntity('StudentParentEntity')
class StudentParentEntity extends BaseEntity {
    name: string;
    birthdate: Date | null;
    passportSerial: string;
    passportNumber: string;
    passportIssued: string;
    address: string;
    phone: string;
    email: string;

    constructor(entity: Entity) {
        super(entity);

        this.name = entity?.name ?? '';
        this.birthdate = shapeDate(entity?.birthdate);
        this.passportSerial = entity?.passportSerial ?? '';
        this.passportNumber = entity?.passportNumber ?? '';
        this.passportIssued = entity?.passportIssued ?? '';
        this.address = entity?.address ?? '';
        this.phone = entity?.phone ?? '';
        this.email = entity?.email ?? '';
    }
}

export { StudentParentEntity };
